import { render, staticRenderFns } from "./DiscountForm.vue?vue&type=template&id=05bb38bf"
import script from "./DiscountForm.vue?vue&type=script&lang=js"
export * from "./DiscountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports